module.exports = __webpack_public_path__ + "img/lagerausbildung-1bohrung_zzz.5e030605.jpg";